import ApiClient from './ApiClient';

class PipelineAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  // POST /pipelines?create_default_stages=true — cria com Frio/Morno/Quente/Link/Venda/Perdido
  createWithDefaults(data) {
    return window.axios.post(`${this.url}?create_default_stages=true`, data);
  }

  // POST /pipelines — cria vazio (admin adiciona stages depois, um por um)
  createEmpty(data) {
    return window.axios.post(this.url, data);
  }
}

export default new PipelineAPI();
